// extracted by mini-css-extract-plugin
module.exports = {"cancelBanner":"cancel-order_cancelBanner__iKqMv"};